import {Component} from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import DialogParmInputModal from './dialog_parm_input_modal';
import FriendDialogDisplay from '../game-views/friend_dialog_display';
import buildCardFromDialog from '../game-views/objectsForCard/build_card_from_dialog';
import { setResponseResultText } from '../game-views/objects/set_response_result_text';
import ConfigFile from '../../datasets/config_file';
import jenniferGameDialogDataset from '../game-views/dialogDatasets/jennifer_game_dialog_dataset';
import charlieGameDialogDataset from '../game-views/dialogDatasets/charlie_game_dialog_dataset';
import cindyGameDialogDataset from '../game-views/dialogDatasets/cindy_game_dialog_dataset';
import cameronGameDialogDataset from '../game-views/dialogDatasets/cameron_game_dialog_dataset';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    // add other Redux state slices here if needed
});

class TestDialog extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            loading: true,
            openDialogParameterModal: false,
            replySelected: false,
         
        }
        this.gameData = null;
        this.friendDisplayType = "";
        this.friendName = "";
        this.dialogIndx = 0;
        this.friendSelected = false;
    }

    componentDidMount(){
        this.loadGame();
    }
    
    loadGame()
    {
        this.gameData = this.props.gameData;
        this.setState({loading: false});
        this.setState({openDialogParameterModal: true});
    }

    openParameterModal(){
        this.friendSelected = false;
        this.friendDisplayType = "openParameterModal";
        this.setState({openDialogParameterModal: true});
    }

    closeParameterModal(){
        this.setState({openDialogParameterModal: false});
    }

    getDialogForSlctdFriend(dialogParameters){
        this.friendName = dialogParameters.friendName;
        switch (this.friendName){
            case "Jennifer":
                this.dialogTable = jenniferGameDialogDataset.dialogTable;
                break;
            case "Charlie":
                this.dialogTable = charlieGameDialogDataset.dialogTable;
                break;
            case "Cindy":
                this.dialogTable = cindyGameDialogDataset.dialogTable;
                break;
            case "Cameron":
                this.dialogTable = cameronGameDialogDataset.dialogTable;
                break;
            default:
                break;
        }
        this.dialogIndx = dialogParameters.dialogIdx;
        this.displayDialogItem();
    }

    displayDialogItem(){
        this.friendDisplayType = "initial";
        let friendList = this.gameData.friendList;
        this.friendInfo = friendList.find(elem => elem.name === this.friendName);
        let dialog = this.dialogTable[this.dialogIndx];
        let selectDialogObj = {title: dialog.title, text: dialog.text, responses: dialog.responses, 
            dialogIndx: 0, nbrDialogItems: this.dialogTable.length};
        this.currentCard = buildCardFromDialog(this.friendName, selectDialogObj, "all");
        this.friendURL = "./assets/friends/" + (this.friendName).toLowerCase() + ".png";
        this.currentCard = {...this.currentCard, friendImgURL: this.friendURL};
        this.title = dialog.title;
        this.dialogLength = (dialog.text).length;
        this.responses = dialog.responses;
        this.nbrDialogItems = selectDialogObj.nbrDialogItems;
        this.friendSelected = true;
        this.setState({replySelected: false});
        this.setState({openDialogParameterModal: false});
    }
      
    resolveDisplayedCard(replyNbr){
        for (let i=0; i<this.gameData.friendList.length; i++){
            if(this.gameData.friendList[i].name === this.friendName){
                this.gameData.friendList[i].rltnshpScore = 
                    +this.gameData.friendList[i].rltnshpScore + 
                        +this.responses[replyNbr].rltnPoints;
                if (this.responses[replyNbr].loanedMoney === true  ||
                    (+this.gameData.friendList[i].totalLoanAmt > 0 &&
                    +this.loanAmt < 0)){
                        this.gameData.friendList[i].totalLoanAmt =
                            +this.gameData.friendList[i].totalLoanAmt +
                                +this.loanAmt;
                }
                break;
            }
        };
      
        this.moodPoints = this.responses[replyNbr].moodPoints;
        // update mood points as a result of dialog item

        this.setState({replySelected: true});
        this.rltnshpPoints = +this.responses[replyNbr].rltnPoints;
        this.moodPointMultiplier = ConfigFile.gameBoard.moodPointMultiplier;
        this.fullMoodPoints = +this.moodPoints * this.moodPointMultiplier;
        this.gameData.currentMoodPoints = +this.gameData.currentMoodPoints + +this.fullMoodPoints;
        this.dialogResultText = setResponseResultText(this.fullMoodPoints, this.rltnshpPoints, this.friendName,
            this.title, this.responses[replyNbr].cashAmt);
        this.cashAmt = 0;    
        if (this.responses[replyNbr].cashAmt){
            this.cashAmt = +this.responses[replyNbr].cashAmt; 
            this.gameData.currentCash = +this.gameData.currentCash + +this.cashAmt;
           
        }
        this.friendDisplayType = "finish";
    }

    getNextFriendDialog(){
        this.dialogIndx +=1;
        let dialogParameters = {friendName: this.friendName, dialogIdx: this.dialogIndx}; 
        this.displayDialogItem(dialogParameters);
        this.friendDisplayType = "initial";
    }

    calculateResponseValue(response)
    {
        let returnValue = this.currentCard.responses[response].value;
        return returnValue;
    }

    
    getPreviousFriendDialog(){
        this.dialogIndx -= 1;
        let dialogParameters = {friendName: this.friendName, dialogIdx: this.dialogIndx}; 
        this.displayDialogItem(dialogParameters);
        this.friendDisplayType = "initial";
    }

    onResultDisplay(){

    }
   
  
    render() { 
         
           
    return <>
        <div className="col-8">
        <div className="card mt-3 mr-5 rounded-corners-lg text-center game-board"
            style={{backgroundImage: `url(${process.env.PUBLIC_URL + this.state.backgroundURL})`}}>
            <h3 className="mt-2 text-center">Special Processes</h3>
            <h5 className="text-center">Test Dialog</h5>
            {this.state.loading  ?
                <WaitTimeSpinner/>
            :
                <span className="mt-2 ml-4 mr-4">
                    <div className="text-right mt-4">
                        <Button variant="primary"  onClick={() => this.openParameterModal()}>
                            Select A Friend
                        </Button>
                    </div>
                    
                </span>
            }
           
            {this.state.openDialogParameterModal ?
                    <DialogParmInputModal  
                        openModal={this.state.openDialogParameterModal} 
                        friendList={this.gameData.friendList}
                        onClose={() => this.closeParameterModal()} 
                        onSubmit={(dialogParameters) => this.getDialogForSlctdFriend(dialogParameters)}
                    />
            :
                    null
            }

            {this.friendDisplayType === "initial" ?
                <span >
                    <div >
                <FriendDialogDisplay
                    currentCard={this.currentCard}
                    onResultDisplay={()=>this.onResultDisplay()}
                    calcResponseValue={(response) => this.calculateResponseValue(response)}
                    onComplete={(selectedInd)=>this.resolveDisplayedCard(selectedInd)}
                />
                                        
                    <div className="dialog-info-position text-left">
                            <div> 
                                Total Dialog Items: {this.nbrDialogItems}
                            </div>
                            <div>
                                Current Dialog Item: {this.dialogIndx + 1}
                            </div>
                            <div>
                                Length of Dialog Text: {this.dialogLength};
                            </div>
                            <div className="mt-2 font-weight-bold">
                                Cumulative (calculated) Totals:
                            </div>
                            <div>
                                Mood Points: {this.gameData.currentMoodPoints}
                            </div>
                            <div>
                                Relationship Score: {this.friendInfo.rltnshpScore}
                            </div>
                            <div>
                                Cash Amount: ${this.gameData.currentCash}
                            </div>

                            {this.state.replySelected ?
                                <span>
                                <div className="mt-2 font-weight-bold">
                                    Amounts for This Dialog Item:
                                </div>
                                <div>
                                    Mood Points: {+this.moodPoints * +this.moodPointMultiplier}
                                </div>
                                <div>
                                    Relationship Points: {this.rltnshpPoints}
                                </div>
                                <div>
                                    Cost Amount: {this.cashAmt}
                                </div>
                             
                            </span>
                            :
                               null
                                
                            }
                    </div>
                   </div>
                </span>
            :
                 null
            }
            {this.friendDisplayType === "finish"  ?
                <div className="row">
                    <div className="col-md text-center mt-4 mx-2">
                        <Button className="mx-2" variant="primary"  onClick={() => this.getPreviousFriendDialog()}>
                            Previous Card
                        </Button>
                        <Button className="mx-2" variant="primary"  onClick={() => this.getNextFriendDialog()}>
                            Next Card
                        </Button>
                    </div>
                    <div className="col-md"></div>
                    </div>
            :
                null
            }
            </div>        
        </div>
     </>
    }

}


export default connect(mapStateToProps)(TestDialog);